import styled from "styled-components";

export const ExtractReportStyled = styled.div`

 background-color: rgba(33, 33, 33);
 min-height: 100vh;


 >.c{
    display: flex;
    flex-wrap: wrap;
    margin: 0 25px;
    padding-bottom: 25px;
    justify-content: center;

    .h {
        min-height: 35px;
        width: 100%;
        display: flex;
        margin-top: 25px;
        -webkit-box-pack: end;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 8px;
        .c4{
            height: 35px;
            padding: 0 15px;
            display: flex;
            align-items: center;
            font-family: 'Lato Bold';
            color: rgb(254, 219, 71);
        }

        .c3{
            height: 35px;
            padding: 0 15px;
            display: flex;
            align-items: center;
            font-family: 'Lato Bold';
            .c4{
                color: rgb(254, 219, 71);
                padding: 0 15px;
                height: 100%;
                img {
                    max-height: 80%;
                    max-width: 100%;
                    padding-top: 2px;
                    cursor: pointer;
                }
                p{
                    padding-top: 8px;
                }
            }
            .i{
                height: 35px;
                display: flex;
                -webkit-box-align: center;
                background: #000;
                color: rgb(254, 219, 71);
                align-items: center;
                border-radius: 7px;
                padding: 0 15px;
                font-size: 15px;
                font-family: 'Lato Bold';
                min-width: 165px;    
                justify-content: center;
            }
            .i2{
                color: #fff
            }

        }
    }

    >.c1 {
        display: flex;
        width: 100%;
        gap: 0 25px;
        flex-wrap: nowrap;
    }
    >.c2{
        width: 100%;
    }
 }

 @media only screen and (max-width: 600px) {
    >.c {
        margin: 0 15px;
        >.h {
            margin-top: 15px;
            justify-content: center;
            flex-direction: column-reverse;
            >.c3 {
                padding: 0;
                >.c4 {
                    padding-left:0 ;
                  
                }
                .i2  {
                        margin-right: 15px;
                    }
            }
        }
        >.c1 {
        flex-wrap: wrap;
        
    }
    }
    
 }
 
 `